import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const ApplePayDisabledMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={52} height={32} viewBox="0 0 52 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3833" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H48C50.2091 0 52 1.79086 52 4V28C52 30.2091 50.2091 32 48 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H48C50.2091 0 52 1.79086 52 4V28C52 30.2091 50.2091 32 48 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H48V0V-1H4V0ZM52 4H51V28H52H53V4H52ZM48 32V31H4V32V33H48V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM52 28H51C51 29.6569 49.6569 31 48 31V32V33C50.7614 33 53 30.7614 53 28H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3833)"
      />
      <Path
        d="M14.969 10.435C15.391 9.91434 15.6773 9.21518 15.6018 8.50073C14.9841 8.53103 14.2303 8.90278 13.7939 9.4239C13.402 9.87015 13.0552 10.5986 13.1456 11.2831C13.839 11.3424 14.5318 10.9411 14.969 10.435Z"
        fill="#B8B8B8"
      />
      <Path
        d="M15.594 11.416C14.587 11.3568 13.7308 11.9798 13.2499 11.9798C12.7687 11.9798 12.0323 11.4458 11.2358 11.4602C10.1991 11.4752 9.23717 12.0535 8.7111 12.9732C7.62905 14.8131 8.42554 17.5423 9.47778 19.0407C9.98877 19.7821 10.6046 20.5984 11.416 20.569C12.1827 20.5394 12.4832 20.0793 13.4152 20.0793C14.3464 20.0793 14.6171 20.569 15.4287 20.5542C16.2703 20.5394 16.7965 19.8125 17.3075 19.0704C17.8937 18.2253 18.1337 17.4093 18.1487 17.3645C18.1336 17.3497 16.5258 16.7412 16.5109 14.9166C16.4958 13.3888 17.7732 12.6621 17.8334 12.6171C17.112 11.5645 15.9848 11.4458 15.594 11.416Z"
        fill="#B8B8B8"
      />
      <Path
        d="M24.362 9.34864C26.5508 9.34864 28.0749 10.8371 28.0749 13.0041C28.0749 15.1788 26.5194 16.675 24.3071 16.675H21.8838V20.477H20.1329V9.34863L24.362 9.34864ZM21.8838 15.2251H23.8928C25.4172 15.2251 26.2848 14.4154 26.2848 13.0118C26.2848 11.6083 25.4172 10.8063 23.9006 10.8063H21.8838V15.2251Z"
        fill="#B8B8B8"
      />
      <Path
        d="M28.5323 18.1712C28.5323 16.7521 29.6346 15.8807 31.589 15.7727L33.8401 15.6417V15.0171C33.8401 14.1147 33.2225 13.5749 32.1909 13.5749C31.2135 13.5749 30.6038 14.0375 30.4554 14.7625H28.8607C28.9545 13.2972 30.2208 12.2175 32.2533 12.2175C34.2466 12.2175 35.5207 13.2586 35.5207 14.8859V20.477H33.9026V19.1428H33.8637C33.3869 20.0452 32.3471 20.6158 31.2684 20.6158C29.6581 20.6158 28.5323 19.6287 28.5323 18.1712ZM33.8401 17.4386V16.7985L31.8155 16.9218C30.807 16.9913 30.2365 17.4309 30.2365 18.1249C30.2365 18.8343 30.8305 19.2971 31.7373 19.2971C32.9177 19.2971 33.8401 18.495 33.8401 17.4386Z"
        fill="#B8B8B8"
      />
      <Path
        d="M37.0481 23.4615V22.1119C37.173 22.1427 37.4543 22.1427 37.5952 22.1427C38.3768 22.1427 38.799 21.8189 39.0568 20.986C39.0568 20.9705 39.2055 20.4924 39.2055 20.4847L36.2351 12.364H38.0641L40.1436 18.9655H40.1747L42.2543 12.364H44.0365L40.9564 20.9011C40.2531 22.8677 39.4401 23.5001 37.736 23.5001C37.5952 23.5001 37.173 23.4846 37.0481 23.4615Z"
        fill="#B8B8B8"
      />
    </Svg>
  )
}
